module.exports = __webpack_public_path__ + "images/154_640.jpg";